export default {
  addCount ({ commit }, count) {
    commit('count', count)
  },
  // 侧边栏数据
  sideNav ({ commit }, nav) {
    commit('sideNav', nav)
  },
  // 用户权限及可访问路由数据
  addRole ({ commit }, roleInfo) {
    commit('addRole', roleInfo)
  },
  // 权限树数据
  setPermissionTree ({ commit }, permissionTree) {
    commit('setPermissionTree', permissionTree)
  },
  // 将目标路由添加到激活状态路由列表
  setActiveTabs ({ commit }, activeTabs) {
    commit('setActiveTabs', activeTabs)
  },
  // 将目标路由从激活状态路由列表中移除
  removeActiveTabs ({ commit }, tabIndex) {
    commit('removeActiveTabs', tabIndex)
  },
  // 以当前页面路由名为激活状态路由
  setActiveTab ({ commit }, activeTab) {
    commit('setActiveTab', activeTab)
  },
  // 重置激活状态路由列表
  resetActiveTabsList ({ commit }, activeTabsList) {
    commit('resetActiveTabsList', activeTabsList)
  },
  // 菜单树数据
  setMenuTree ({ commit }, menuTree) {
    commit('setMenuTree', menuTree)
  },
  // 用户信息
  setUserInfo ({ commit }, userInfo) {
    commit('setUserInfo', userInfo)
  },
  // 存储组织管理树数据
  setOrgainzationTree ({ commit }, orgainzationTree) {
    commit('setOrgainzationTree', orgainzationTree)
  },
  setEntityTree ({ commit }, entityTree) {
    commit('setEntityTree', entityTree)
  },
  // 设置页面模块维护树
  setPageComTree ({ commit }, pageComTree) {
    commit('setPageComTree', pageComTree)
  },
  setPageIndicatorTree ({ commit }, data) {
    commit('setPageIndicatorTree', data)
  },

  // 设置页面实例树
  setPageInstanceTree ({ commit }, pageInstanceTree) {
    commit('setPageInstanceTree', pageInstanceTree)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js